<template>
  <el-dialog
    v-model="dialogFormVisible"
    :close-on-click-modal="false"
    :title="title"
    width="80%"
    @close="close"
  >
    <el-form ref="form" label-width="100px" :model="form" :rules="rules">
      <el-form-item label="街区名称" prop="title">
        <el-input v-model="form.title" class="custom-input" />
      </el-form-item>
      <el-form-item label="所属州" prop="provinceId">
        <el-select v-model="form.provinceId" placeholder="请选择">
          <el-option
            v-for="item in provinces"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="排序" prop="order">
        <el-input-number v-model="form.order" />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="save">确 定</el-button>
    </template>
  </el-dialog>
</template>

<script>
import { createCity, editCity, getProvinceAll } from '@/api/apartment'
export default {
  name: 'Edit',
  emits: ['fetch-data'],
  data() {
    return {
      list: [],
      form: {
        title: '',
        provinceId: '',
        order: '',
      },
      rules: {
        title: [{ required: true, trigger: 'blur', message: '请输入街区名称' }],
        provinceId: [{ required: true, trigger: 'blur', message: '请选择所属州' }]
      },
      provinces: [],
      title: '',
      dialogFormVisible: false,
    }
  },
  methods: {
    async showEdit(row) {
      if (row.cityId) {
        this.title = '编辑街区'
        this.form = Object.assign(this.form, {
          provinceId: row.provinceId,
          cityId: row.cityId,
          title: row.title,
          order: row.basic && row.basic.order,
        })
      } else {
        this.title = '新增街区'
      }
      const result = await getProvinceAll({})
      this.provinces = result.map(i => ({
        label: i.title,
        value: i.provinceId
      }))
      this.dialogFormVisible = true
    },
    close() {
      this.$refs['form'].resetFields()
      this.form = this.$options.data().form
      this.dialogFormVisible = false
    },
    async save() {
      this.$refs['form'].validate(async (valid) => {
        const isEdit = !!this.form.cityId
        this.$baseConfirm(
          `你确定${isEdit ? '修改' : '新增'}吗`,
          null,
          async () => {
            isEdit
              ? await editCity({ ...this.form })
              : await createCity({ ...this.form })
            this.$baseMessage(
              `${isEdit ? '修改' : '新增'}成功`,
              'success',
              false,
              'vab-hey-message-success'
            )
            this.$emit('fetch-data')
            this.close()
          }
        )
      })
    },
  },
}
</script>

<style style="scss">
.custom-input {
  width: 216px;
}
</style>
